import { render } from "./px-form-modal.vue?vue&type=template&id=07649442&ts=true"
import script from "./px-form-modal.vue?vue&type=script&lang=ts"
export * from "./px-form-modal.vue?vue&type=script&lang=ts"

import "./px-form-modal.vue?vue&type=style&index=0&id=07649442&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__